import CartForm from '@archetype-themes/modules/cart-form';
import { EVENTS } from '@archetype-themes/utils/events';

class HeaderCart extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.cartForm = new CartForm(this.form);
    this.cartForm.buildCart();

    document.addEventListener(EVENTS.ajaxProductAdded, this.handleCartChange.bind(this), {
      signal: this.abortController.signal
    });
  }

  async handleCartChange(evt) {
    this.cartForm.cartMarkup(evt.detail.product.sections['cart-ajax']);

    if (!evt?.detail?.preventCartOpen) {
      this.dispatchEvent(new CustomEvent(EVENTS.cartOpen, { bubbles: true }));
    }

    if (this.cartForm.cartItemsUpdated) {
      this.cartForm.cartItemsUpdated = false;
    }

    // Ensure scroll is enabled
    this.enableCartDrawerScroll();

    // Increase the cart drawer width
    this.increaseCartDrawerWidth();

    // Show header after product is added
    requestAnimationFrame(() => {
      const drawer = document.querySelector('.cart-drawer');
      const header = drawer?.querySelector('.cart__header');
      if (header) {
        header.style.display = 'flex';
        header.style.visibility = 'visible';
        header.style.opacity = '1';
        header.style.transform = 'translateY(0)';
      }
    });
  }

  // Function to enable scroll inside the cart drawer
  enableCartDrawerScroll() {
    const drawer = document.querySelector('.cart-drawer');
    const content = drawer?.querySelector('.cart-drawer__content'); // Assuming this is where the cart items are.

    if (content) {
      content.style.overflow = 'auto'; // Enables both horizontal and vertical scrolling.
      content.style.maxHeight = '70vh'; // Set a max height to make vertical scroll appear if needed.
      content.style.maxWidth = '100%'; // Ensure horizontal scrolling if content is wider than the drawer.
      content.style.paddingRight = '15px'; // Space for scrollbar if needed.

      // Optional: Add custom scrollbar styling
      content.style.scrollbarWidth = 'thin';
      content.style.scrollbarColor = '#888 #f1f1f1'; // Dark scrollbar on light background
    }
  }

  // Function to increase the cart drawer width
  increaseCartDrawerWidth() {
    const drawer = document.querySelector('.cart-drawer');
    if (drawer) {
      drawer.style.width = '80vw'; // Increase width to 80% of the viewport width
      drawer.style.maxWidth = '100%'; // Ensure it doesn't exceed screen width
      drawer.style.transition = 'width 0.3s ease'; // Optional: Add a smooth transition for width change
    }
  }
}

customElements.define('header-cart-drawer', HeaderCart);

// -------- CART DRAWER CLOSE WITH SLIDE-UP -------- //

function closeCartDrawerWithSlideUp() {
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');

  if (drawer) {
    drawer.classList.remove('is-open');
    drawer.classList.add('is-sliding-up');
    drawer.setAttribute('aria-hidden', 'true');

    // Wait for animation to finish before hiding
    setTimeout(() => {
      drawer.classList.remove('is-sliding-up');
      drawer.style.display = 'none';
    }, 300); // match CSS transition duration
  }

  if (overlay) {
    overlay.style.opacity = '0';
    overlay.style.visibility = 'hidden';
    overlay.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const closeBtn = document.querySelector('.cart__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeCartDrawerWithSlideUp);
  }
});

// -------- HEADER FIX ON OPEN/UPDATE -------- //

function showCartHeaderFix() {
  const drawer = document.querySelector('.cart-drawer');
  const header = drawer?.querySelector('.cart__header');
  if (header && drawer.classList.contains('is-open')) {
    header.style.display = 'flex';
    header.style.visibility = 'visible';
    header.style.opacity = '1';
    header.style.transform = 'translateY(0)';
  }
}

document.addEventListener('cart:updated', () => {
  setTimeout(showCartHeaderFix, 100);
});

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.cart-drawer');
  if (drawer) {
    drawer.addEventListener('transitionend', () => {
      setTimeout(showCartHeaderFix, 50);
    });
  }
});
